/**
 * Escapes special characters in a string for safe use within XML.
 * @param unsafeString - The raw string that may contain XML special characters.
 * @returns The escaped XML-safe string.
 */
export const escapeXml = (unsafeString: string): string =>
  unsafeString.replace(/[<>&'"]/g, (match) => {
    switch (match) {
      case "<":
        return "&lt;";
      case ">":
        return "&gt;";
      case "&":
        return "&amp;";
      case "'":
        return "&apos;";
      case '"':
        return "&quot;";
      default:
        return match;
    }
  });
